import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../common/locale/translate';
import {
  createRegionsObject,
  fetchFilterData,
  isFilterExpired,
  localstorageAvailable,
  numeralTranslation,
  replaceForeignCharacters
} from '../../services/services';

export default class Destination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      placeholder: [],
      active: false,
      active_input: true,
      regions: {},
      regions_list: [],
      special_regions: [],
      chosen_destionation: [],
      open_subregions: [],
      open_chosen_subregions: [],
      counter: 0,
      filterDataCacheTime: 900000 // in miliseconds
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
    this.setInitialData();
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => {
    this.state.counter = 0;
    let destinations = this.renderDestinations();
    let chosenDestinations = this.renderChosenDestinations();

    return (
      <div
        className={
          'destination select-wrapper animated-text-form extended ' +
          (this.state.active ? 'active' : '')
        }
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <label className="animated-text-label">
          {' '}
          <span className="animated-text-label-name">
            {this.props.title}
          </span>{' '}
        </label>
        <i className="dropdown-icon fa fa-chevron-down" />
        <img
          className="input-icon"
          src="/img/icons/search/destination.svg"
          alt=""
        />
        <div className="desktop">
          <input
            type="text"
            value={this.state.value}
            className="animated-text-input"
            placeholder={this.formatPlaceholder()}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
        </div>
        <div className="mobile">
          <label className="animated-text-label" onClick={this.handleOpen}>
            <span className="animated-text-input">
              {this.formatPlaceholder()}
            </span>
          </label>
        </div>
        <div className="dropdown-menu">
          <div className="dropdown-input-wrapper mobile">
            <label className="animated-text-label" htmlFor="mobile-stars">
              {' '}
              <span className="animated-text-label-name">
                {this.props.title}
              </span>{' '}
            </label>
            <img
              className="dropdown-icon"
              src="/img/icons/search/destination.svg"
              alt=""
            />
            <input
              id="mobile-stars"
              type="text"
              value={this.state.value}
              className="animated-text-input"
              placeholder={this.formatPlaceholder()}
              onChange={this.handleChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            />
          </div>
          <div className="reset-filter-custom mobile">
            <span onClick={this.handleReset} className="reset">
              <span> {T('clear')} </span>
            </span>
            <span onClick={this.handleClose} className="confirm">
              <span> {T('choose')} </span>
            </span>
          </div>
          <i className="fa fa-times close-icon" onClick={this.handleClose} />
          <div className="destinations-list">
            <div className="dropdown-wrapper">{destinations}</div>
          </div>

          <div className="destinations-chosen">
            <div className="dropdown-header">
              <span> {T('chosen_directions')} </span>
            </div>
            <div className="reset-filter-custom">
              <span onClick={this.handleReset} className="reset">
                <i className="fa fa-times reset-icon" />
                <span> {T('clear')} </span>
              </span>
              <span onClick={this.handleClose} className="confirm">
                <span> {T('choose')} </span>
              </span>
            </div>
            <div className="dropdown-wrapper">{chosenDestinations}</div>
          </div>
        </div>
      </div>
    );
  };

  setInitialData = () => {
    if (localstorageAvailable()) {
      if (isFilterExpired('regions', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(localStorage.getItem('regions_filter'));
        this.setState(
          {
            regions: filter_data.regions,
            regions_list: filter_data.regions_list,
            special_regions: filter_data.special_regions
          },
          () => {
            this.setInitialChosenDestinations();
          }
        );
      }
    } else {
      this.updateFilterSource();
    }
  };

  updateFilterSource = () => {
    fetchFilterData('regions_filter').then(
      response => {
        const filter_data = createRegionsObject(response.data);
        if (localstorageAvailable()) {
          localStorage.setItem('regions_filter', JSON.stringify(filter_data));
          localStorage.setItem(
            'regions_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState(
          {
            regions: filter_data.regions,
            regions_list: filter_data.regions_list,
            special_regions: filter_data.special_regions
          },
          () => {
            this.setInitialChosenDestinations();
          }
        );
      },
      error => {
        console.log('Error when fetching regions filter', error);
      }
    );
  };

  setInitialChosenDestinations = () => {
    if (typeof this.props.regions != 'undefined') {
      let destinations = this.props.regions.split(',').map(v => parseInt(v));
      let element,
        isParent,
        placeholder,
        chosen_destionation = this.state.chosen_destionation;
      destinations.map(code => {
        element = this.state.regions[code];
        isParent = element.subregions || !element.parent ? true : false;

        if (isParent) {
          element.checked = true;
          if (chosen_destionation.indexOf(element.id) === -1) {
            chosen_destionation.push(element.id);
          }
        } else if (!isParent && element.parent) {
          element.checked = true;
          this.state.regions[element.parent].chosen_count += 1;
          this.state.regions[element.parent].indeterminate = true;
          this.state.regions[element.parent].checked = false;
          if (chosen_destionation.indexOf(element.parent) === -1) {
            chosen_destionation.push(element.parent);
          }
        } else {
          element.checked = true;
        }
      });

      placeholder = chosen_destionation.map(v => this.state.regions[v].name);
      this.setState({ chosen_destionation, placeholder });
    }
  };

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false, value: '' });
    }
  };

  handleChange = event => {
    this.setState({
      value: event.target.value.replace(/[.*+?^${}()|[\]\\]/g, '')
    });
  };

  formatPlaceholder = () => {
    // TODO: ograniczyć po ilości znaków a nie po ilości kierunków
    let placeholder = this.state.placeholder
      .join()
      .split(',')
      .join(', ');
    return this.state.placeholder.length > 4
      ? `${T('chosen')} ${this.state.placeholder.length} ${numeralTranslation(
          this.state.placeholder.length,
          [
            T('destination'),
            T('destinations_first_plural'),
            T('destinations_second_plural')
          ]
        )}`
      : placeholder;
  };

  handleCheckboxChange = id => {
    let element = this.state.regions[id];
    let chosen_destionation = this.state.chosen_destionation;
    let isParent = element.subregions || !element.parent ? true : false;
    let open_chosen_subregions = this.state.open_chosen_subregions;

    if (element.checked) {
      element.checked = false;
      if (isParent) {
        // main region
        chosen_destionation = chosen_destionation.filter(v => v !== id);
        open_chosen_subregions = open_chosen_subregions.filter(v => v !== id);
        if (element.subregions) {
          element.subregions.map(v => {
            this.state.regions[v].checked = false;
          });
          element.indeterminate = false;
          element.chosen_count = 0;
        }
      } else {
        // subregions
        let parent = this.state.regions[element.id].parent;
        if (parent) {
          this.state.regions[parent].chosen_count -= 1;
          if (this.state.regions[parent].chosen_count == 0) {
            this.state.regions[parent].checked = false;
            chosen_destionation = chosen_destionation.filter(v => v !== parent);
            this.foldChosenList(parent);
          }
        }
      }
    } else {
      // if not checked element
      element.checked = true;
      let parentId = this.state.regions[element.id].parent;
      if (isParent) {
        if (chosen_destionation.indexOf(element.id) === -1) {
          chosen_destionation.push(element.id);
        }
        if (element.indeterminate) {
          element.subregions.map(v => {
            this.state.regions[v].checked = false;
          });
          element.checked = true;
          element.indeterminate = false;
          element.chosen_count = 0;
        }
      } else if (parentId) {
        this.state.regions[parentId].chosen_count += 1;
        if (chosen_destionation.indexOf(parentId) === -1) {
          chosen_destionation.push(parentId);
        }
        this.expadChosenList(parentId);
      }
    }

    if (!isParent && element.parent) {
      const counter = this.state.regions[element.parent].chosen_count;
      const subregions_number = this.state.regions[element.parent].subregions
        .length;
      let parent = this.state.regions[element.parent];

      parent.indeterminate = counter > 0 && counter < subregions_number;
      if (parent.indeterminate) {
        parent.checked = false;
      }
      if (counter === subregions_number) {
        parent.checked = true;
      }
    }
    let placeholder = chosen_destionation.map(v => this.state.regions[v].name);
    this.setState({ chosen_destionation, placeholder, open_chosen_subregions });
  };

  expadChosenList = list_parent_id => {
    let tmp_opened_list = this.state.open_chosen_subregions;
    if (tmp_opened_list.indexOf(list_parent_id) > -1) {
      return;
    }
    tmp_opened_list.push(list_parent_id);
    this.setState({ open_chosen_subregions: tmp_opened_list });
  };

  foldChosenList = list_parent_id => {
    let tmp_opened_list = this.state.open_chosen_subregions;
    let index = tmp_opened_list.indexOf(list_parent_id);
    if (index > -1) {
      tmp_opened_list.splice(index, 1);
    }
    this.setState({ open_chosen_subregions: tmp_opened_list });
  };

  removeChosenDestination = id => {
    let element = this.state.regions[id];
    let chosen_destionation = this.state.chosen_destionation;
    let open_chosen_subregions = this.state.open_chosen_subregions;
    let isParent = element.subregions || !element.parent;

    if (isParent) {
      element.checked = false;
      element.chosen_count = 0;
      element.indeterminate = false;
      chosen_destionation = chosen_destionation.filter(v => v !== element.id);
      open_chosen_subregions = open_chosen_subregions.filter(
        v => v !== element.id
      );
      if (element.subregions) {
        element.subregions.map(v => {
          this.state.regions[v].checked = false;
        });
      }
    } else {
      element.checked = false;
      if (element.parent) {
        let parent = this.state.regions[element.parent];
        parent.chosen_count -= 1;
        if (parent.chosen_count > 0) {
          parent.indeterminate = true;
        } else {
          parent.indeterminate = false;
          parent.checked = true;
        }
      }
    }

    let placeholder = chosen_destionation.map(v => this.state.regions[v].name);
    this.setState({ chosen_destionation, placeholder, open_chosen_subregions });
  };

  handleOpen = () => {
    let placeholder = this.state.chosen_destionation.map(
      v => this.state.regions[v].name
    );
    this.setState({
      active: true,
      active_input: true,
      placeholder: placeholder
    });
  };

  handleBlur = () => {
    let placeholder = this.state.chosen_destionation.map(
      v => this.state.regions[v].name
    );
    this.setState({ active_input: true, placeholder: placeholder });
  };

  handleFocus = () => {
    this.setState({ active: true, active_input: false, placeholder: [] });
  };

  handleClose = () => this.setState({ active: false, value: '' });

  handleReset = () => {
    this.state.chosen_destionation.map(v => {
      if (this.state.regions[v].subregions != undefined) {
        this.state.regions[v].subregions.map(s => {
          this.state.regions[s].checked = false;
        });
      }

      this.state.regions[v].checked = false;
      this.state.regions[v].chosen_count = 0;
      this.state.regions[v].indeterminate = false;
    });
    this.setState({
      chosen_destionation: [],
      open_chosen_subregions: [],
      placeholder: []
    });
  };

  renderDestinations = () =>
    this.state.value !== ''
      ? this.renderSearchedDestinations()
      : this.renderDefaultDestinations();

  renderChosenDestinations = () => {
    let destinations = this.state.chosen_destionation;
    return this.renderChosenDestinationElement(destinations);
  };

  handleSubregionsIndicatorClick = id => {
    if (this.state.open_subregions.indexOf(id) > -1) {
      let open_subregions = this.state.open_subregions.filter(v => v !== id);
      this.setState({ open_subregions });
    } else {
      let open_subregions = this.state.open_subregions;
      open_subregions.push(id);
      this.setState({ open_subregions });
    }
  };

  handleSubregionLabelClick = id => {
    if (
      this.state.regions[id].checked &&
      this.state.open_subregions.indexOf(id) > -1
    ) {
      let open_subregions = this.state.open_subregions.filter(v => v !== id);
      this.setState({ open_subregions });
    } else {
      let open_subregions = this.state.open_subregions;
      if (this.state.open_subregions.indexOf(id) === -1) {
        open_subregions.push(id);
      }
      this.setState({ open_subregions });
    }
  };

  handleChosenSubregionsIndicatorClick = id => {
    if (this.state.open_chosen_subregions.indexOf(id) > -1) {
      let open_chosen_subregions = this.state.open_chosen_subregions.filter(
        v => v !== id
      );
      this.setState({ open_chosen_subregions });
    } else {
      let open_chosen_subregions = this.state.open_chosen_subregions;
      open_chosen_subregions.push(id);
      this.setState({ open_chosen_subregions });
    }
  };

  renderDestinationElement = (destinations, nameSuffix) => {
    const suffix = nameSuffix ? nameSuffix : '';
    return destinations.map((region, i) => {
      const destination = this.state.regions[region];
      if (destination.subregions || !destination.parent) {
        // main region

        let isOpen = this.state.open_subregions.indexOf(destination.id) > -1;
        let indeterminate = this.state.regions[destination.id].indeterminate
          ? true
          : false;
        let checked = this.state.regions[destination.id].checked ? true : false;
        let arrow = destination.subregions ? (
          <i
            className={
              'subregions-indicator fa ' +
              (isOpen ? 'fa-chevron-up' : 'fa-chevron-down')
            }
            onClick={this.handleSubregionsIndicatorClick.bind(
              this,
              destination.id
            )}
          />
        ) : (
          ''
        );
        this.state.counter += checked && !destination.subregions ? 1 : 0;

        return (
          <li
            key={`left-${destination.id}`}
            className={'item parent-element ' + (isOpen ? 'open' : 'closed')}
          >
            <input
              type="checkbox"
              id={`${destination.id}${i}${suffix}`}
              className="filled-in"
              name="destination"
              value={destination.id}
              onChange={this.handleCheckboxChange.bind(this, destination.id)}
              checked={checked}
              ref={input => {
                if (input) {
                  ReactDOM.findDOMNode(input).indeterminate = indeterminate;
                }
              }}
            />
            <label
              htmlFor={`${destination.id}${i}${suffix}`}
              onClick={this.handleSubregionLabelClick.bind(
                this,
                destination.id
              )}
            >
              {' '}
              {destination.name}{' '}
            </label>{' '}
            {arrow}
            {destination.subregions ? (
              <ul className="dropdown-wrapper child-wrapper">
                {' '}
                {this.renderDestinationElement(
                  destination.subregions,
                  suffix
                )}{' '}
              </ul>
            ) : (
              ''
            )}
          </li>
        );
      } else {
        // subregions

        let checked = this.state.regions[destination.id].checked ? true : false;
        this.state.counter += checked ? 1 : 0;

        return (
          <li key={`left-${destination.id}`} className="item child-element">
            <input
              type="checkbox"
              id={`${destination.id}${i}${suffix}`}
              name="destination"
              value={destination.id}
              onChange={this.handleCheckboxChange.bind(this, destination.id)}
              checked={checked}
            />
            <label htmlFor={`${destination.id}${i}${suffix}`}>
              {' '}
              {destination.name}{' '}
            </label>
          </li>
        );
      }
    });
  };

  renderChosenDestinationElement = destinations => {
    return destinations.map((region, i) => {
      const destination = this.state.regions[region];
      const isParent = destination.main || !destination.parent;
      let isChecked = false;
      if (isParent) {
        let isOpen =
          this.state.open_chosen_subregions.indexOf(destination.id) > -1;
        isChecked =
          this.state.regions[destination.id].indeterminate ||
          this.state.regions[destination.id].checked;
        let arrow = destination.subregions ? (
          <i
            className={
              'subregions-indicator fa ' +
              (isOpen ? 'fa-chevron-up' : 'fa-chevron-down')
            }
            onClick={this.handleChosenSubregionsIndicatorClick.bind(
              this,
              destination.id
            )}
          />
        ) : (
          ''
        );
        return (
          <li
            key={`right-${destination.id}`}
            className={'item parent-element ' + (isOpen ? 'open' : 'closed')}
          >
            <span>
              <i
                className="fa fa-times remove-icon"
                onClick={this.removeChosenDestination.bind(
                  this,
                  destination.id
                )}
              />{' '}
              {destination.name} {arrow}{' '}
            </span>
            {destination.subregions ? (
              <ul className="dropdown-wrapper child-wrapper">
                {' '}
                {this.renderChosenDestinationElement(
                  destination.subregions
                )}{' '}
              </ul>
            ) : (
              ''
            )}
          </li>
        );
      } else {
        isChecked =
          this.state.regions[destination.id].indeterminate ||
          this.state.regions[destination.id].checked;
        let element = (
          <li key={`right-${destination.id}`} className="item child-element">
            <span>
              <i
                className="fa fa-times remove-icon"
                onClick={this.removeChosenDestination.bind(
                  this,
                  destination.id
                )}
              />{' '}
              {destination.name}
            </span>
          </li>
        );

        return isChecked ? element : '';
      }
    });
  };

  renderDestinationGroups = () => {
    let special_regions = this.state.special_regions;
    return special_regions.map((group, index) => (
      <div key={index}>
        <div className="dropdown-header">
          <span> {group.name} </span>
        </div>
        <ul className="dropdown-wrapper">
          {this.renderDestinationElement(group.subregions, 'special-regions')}
        </ul>
      </div>
    ));
  };

  renderDefaultDestinations = () => {
    let main_destinations = this.state.regions.main_regions || [];

    return (
      <div className="airports-wrapper">
        {this.renderDestinationGroups()}
        <div className="dropdown-header">
          <span> {T('destinations')} </span>
        </div>
        <ul className="dropdown-wrapper">
          {this.renderDestinationElement(main_destinations)}
        </ul>
      </div>
    );
  };

  renderSearchedDestinations = () => {
    let search = new RegExp(replaceForeignCharacters(this.state.value), 'i');
    let searched_destinations = this.state.regions_list.filter(code =>
      search.test(this.state.regions[code].unicodeName)
    );
    let destinations = this.renderDestinationElement(searched_destinations);

    return (
      <div>
        <div className="dropdown-header">
          <span> {T('destinations')} </span>
        </div>
        <ul className="dropdown-wrapper">
          {destinations.length ? destinations : T('no_destinations')}
        </ul>
      </div>
    );
  };

  returnSearchedValue = () => {
    let regions = this.state.regions;
    let temp = [];
    this.state.chosen_destionation.map(v => {
      if (regions[v].checked) {
        temp.push(v);
      } else if (regions[v].indeterminate) {
        if (regions[v].subregions) {
          regions[v].subregions.map(id => {
            if (regions[id].checked) {
              temp.push(id);
            }
          });
        }
      }
    });

    return temp.length ? temp : false;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/destination.js